/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-syntax */
import "./style.css";
import lod_ from "lodash";
import {
	CircularProgress,
	Divider,
	FormControl,
	InputLabel,
	MenuItem,
	Select
} from "@mui/material";
import MDBox from "components/Basics/MDBox";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MDInput from "components/Basics/MDInput";
import MDButton from "components/Basics/MDButton";
import InputMapping from "components/Custom/LittleForm/Inputs/InputMapping";
import FormActions from "redux-react/actions/formAction";
import settingsActions from "redux-react/actions/settingsActions";
import { display } from "redux-react/reducers/snackBarReducer";
import DictionarySelectionDialog from "components/Custom/Dialogs/DictionarySelectionDialog";

const MappingTab = () => {
	const dispatch = useDispatch();

	const [insertInputValue, setInsertInputValue] = useState("");

	const [mappingString, setMappingString] = useState("");

	const [loading, setLoading] = useState(false);

	const [clients, setClients] = useState([]);
	const [assistants, setAssistants] = useState([]);
	const [account, setAccount] = useState("all");
	const [selectedAssistant, setSelectedAssistant] = useState(null);

	const [assistantDictionaries, setAssistantDictionaries] = useState({});

	// const [dictionaries, setDictionaries] = useState({});

	const [selectedDictionaries, setSelectedDictionaries] = useState({});
	const [dictionaryDialogOpen, setDictionaryDialogOpen] = useState(false);

	useEffect(() => {
		dispatch(
			FormActions.getItemsFromCollection(
				"accountConfig",
				{
					catalog: "legacy",
					sort: "accountID"
				},
				({ items }) => {
					return setClients(items);
				}
			)
		);
	}, []);

	const fetchDictionariesMappings = assistantID => {
		setLoading(true);
		dispatch(
			settingsActions.getDictionaries(assistantID, res => {
				const dictionariesResult = res?.dictionaries ?? {};
				setAssistantDictionaries(dictionariesResult);
				setLoading(false);
			})
		);
	};

	const createBaseMapping = string => {
		// 1- Found every values like {{{ xx }}} or {{ xx}}
		const regex = /{{{?\s*([^}]+?)\s*}?}}/g;
		const matches = [...string.matchAll(regex)];

		const results = matches.map(match => match[1].trim());

		const dictionaryPath = [];

		for (let result of results) {
			const parts = result.split(" ");
			switch (parts.length) {
				case 0: {
					break;
				}
				case 1: {
					// No helpers
					dictionaryPath.push(parts[0]);
					break;
				}
				default: {
					// One helper
					dictionaryPath.push(parts[1]);
				}
			}
		}

		const dictionaryKeys = [];

		for (let path of dictionaryPath) {
			const parts = path.split(".");
			if (parts.length > 0 && !dictionaryKeys.includes(parts[0])) {
				dictionaryKeys.push(parts[0]);
			}
		}

		const selectedDictionariesFromKeys = {};

		const unvailableDictionaries = [];

		for (let key of dictionaryKeys) {
			if (assistantDictionaries[key]) {
				selectedDictionariesFromKeys[key] = assistantDictionaries[key];
			} else {
				unvailableDictionaries.push(key);
			}
		}

		setMappingString(string);
		setSelectedDictionaries(selectedDictionariesFromKeys);

		if (unvailableDictionaries.length > 0) {
			dispatch(
				display({
					message: `Les dictionnaires suivants sont introuvables et n'ont pas été ajoutés au mapping : ${unvailableDictionaries.join(", ")}`,
					type: "warning"
				})
			);
		}
	};

	const isDisabled = lod_.isNil(selectedAssistant) || lod_.isEmpty(assistantDictionaries);

	useEffect(() => {
		if (!selectedAssistant) return;

		fetchDictionariesMappings(selectedAssistant);
	}, [selectedAssistant]);

	return (
		<MDBox mt={2} bgColor="white" p={1} borderRadius="md" display="flex" flexDirection="column">
			<MDBox display="flex" flexDirection="column" alignItems="center" sx={{ mt: 1 }}>
				{/* Assistant ID choice */}
				<MDBox display="flex" flexDirection="row" alignItems="center" sx={{ mt: 1, width: "100%" }}>
					<FormControl sx={{ flex: 1 }}>
						<InputLabel id="select-acconut">Account</InputLabel>
						<Select
							labelId="select-account"
							id="select"
							name="target"
							label="Account"
							value={account}
							onChange={e => setAccount(e.target.value)}
						>
							<MenuItem
								value="all"
								onClick={() => {
									setAssistants([]);
								}}
							>
								Choisir
							</MenuItem>
							{clients.map((client, index) => (
								<MenuItem
									key={index}
									value={client.accountID}
									onClick={() => {
										const assistants = client.assistants;
										return setAssistants(
											assistants.sort((a, b) =>
												a.assistantID.toUpperCase().localeCompare(b.assistantID.toUpperCase())
											)
										);
									}}
								>
									{client.name ?? client.accountID}
								</MenuItem>
							))}
						</Select>
					</FormControl>

					<FormControl sx={{ flex: 3, ml: 1 }}>
						<InputLabel id="select-acconut">AssistantID</InputLabel>
						<Select
							disabled={account === "all"}
							labelId="select-assistant"
							id="select"
							name="target"
							label="AssistantID"
							value={selectedAssistant}
							onChange={e => setSelectedAssistant(e.target.value)}
						>
							{assistants.map((assistant, index) => {
								return (
									<MenuItem
										key={index}
										value={assistant.assistantID}
										onClick={() => {
											setSelectedAssistant(assistant.assistants);
										}}
									>
										{assistant.assistantID}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>

					<MDButton
						sx={{ ml: 1 }}
						variant="contained"
						color="info"
						onClick={() => setDictionaryDialogOpen(true)}
						disabled={!selectedAssistant || lod_.isEmpty(assistantDictionaries)}
					>
						{loading && <CircularProgress sx={{ mr: 2 }} size={20} color="white" />}
						Dictionnaires
					</MDButton>
				</MDBox>
				<Divider />
				<MDBox
					flex="1"
					sx={{ wifth: "100%" }}
					display="flex"
					flexDirection="column"
					alignItems="center"
					width="100%"
				>
					{/* Mapping input string */}
					<MDInput
						disabled={isDisabled}
						value={insertInputValue}
						onChange={e => setInsertInputValue(e.target.value)}
						onBlur={e => createBaseMapping(e.target.value)}
						fullWidth
						placeholder='{"conversation": { "id": "1234" }, "message": { "text": "Hello" }}'
						label="Insérer un mapping JSON ici"
					/>
					{/* Mapping object configurator */}
					<MDBox flex="1" mt={1} width="100%">
						<InputMapping
							disabled={isDisabled}
							label="Mapping à jour"
							value={mappingString}
							onChange={newMappingString => {
								// Handle mapping change
								setMappingString(newMappingString);
							}}
							item={{
								config: {
									dictionaries: selectedDictionaries,
									dictionariesInput: [],
									dictionariesOutput: []
								}
							}}
						/>
					</MDBox>
				</MDBox>
			</MDBox>

			<DictionarySelectionDialog
				open={dictionaryDialogOpen}
				handleClose={() => setDictionaryDialogOpen(false)}
				assistantDictionaries={assistantDictionaries}
				selectedDictionaries={selectedDictionaries}
				onSelectionChange={setSelectedDictionaries}
			/>
		</MDBox>
	);
};

export default MappingTab;
